// Variety background images (responsive)
document.addEventListener('DOMContentLoaded', () => {
  const dataEl = document.getElementById('product-dosage-variety-images');

  if (dataEl) {
    const varietyImages = JSON.parse(dataEl.textContent);
    const hasFruitTags = dataEl.dataset.hasFruitTags === 'true';

    const tl = document.querySelector('.fruity-bg--tl');
    const tr = document.querySelector('.fruity-bg--tr');
    const bl = document.querySelector('.fruity-bg--bl');
    const br = document.querySelector('.fruity-bg--br');
    const tc = document.querySelector('.fruity-bg--tc');

    if (!tl && !tr && !bl && !br && !tc) return;

    const mq = window.matchMedia('(max-width: 767.98px)');

    const setSrcOnce = (el, url, mode) => {
      if (!el || !url) return;
      if (el.dataset.bgSetFor === mode || el.getAttribute('src') === url) return;
      el.setAttribute('src', url);
      el.dataset.bgSetFor = mode;
    };

    const apply = () => {
      if (mq.matches) {
        if (!hasFruitTags) setSrcOnce(tl, varietyImages['watermelon-mobile'], 'mobile');
        setSrcOnce(br, varietyImages['raspberry-lime-br'], 'mobile');
      } else {
        if (!hasFruitTags) setSrcOnce(tl, varietyImages['watermelon-tl'], 'desktop');
        setSrcOnce(tr, varietyImages['blueberry-tr'], 'desktop');
        if (!hasFruitTags) setSrcOnce(bl, varietyImages['peach-bl'], 'desktop');
        setSrcOnce(br, varietyImages['raspberry-lime-br'], 'desktop');
        setSrcOnce(tc, varietyImages['raspberry-lime-tc'], 'desktop');
      }
    };
    apply();
    mq.addEventListener('change', apply);
  }
});

// Dosage accordion/tabs
document.addEventListener('DOMContentLoaded', function () {
  const allDosageItems = document.querySelectorAll('.product-dosage__dose');
  const dosageItems = Array.from(allDosageItems).filter(item => !item.classList.contains('dose--info-only'));
  const dosageMediaItems = document.querySelectorAll('.product-dosage__dose-media');

  function forceRedrawSvg(mediaItem) {
    const svgElement = mediaItem.querySelector('svg');
    if (svgElement) {
      const currentViewBox = svgElement.getAttribute('viewBox');
      svgElement.setAttribute('viewBox', '0 0 582.1 552');
      setTimeout(() => {
        svgElement.setAttribute('viewBox', currentViewBox);
      }, 10);
    }
  }

  function handleDosageClick(event) {
    const clickedItem = event.currentTarget;
    const dataIndex = clickedItem.getAttribute('data-index');
    const wasActive = clickedItem.classList.contains('active');

    dosageItems.forEach(item => item.classList.remove('active'));

    if (!wasActive || window.innerWidth >= 992) {
      clickedItem.classList.add('active');
    }

    dosageMediaItems.forEach(mediaItem => {
      if (mediaItem.getAttribute('data-index') === dataIndex && (!wasActive || window.innerWidth >= 768)) {
        mediaItem.classList.remove('d-none');
        forceRedrawSvg(mediaItem);
      } else {
        mediaItem.classList.add('d-none');
      }
    });
  }

  dosageItems.forEach(item => item.addEventListener('click', handleDosageClick));

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 992 && !document.querySelector('.product-dosage__dose.active')) {
      const firstItem = dosageItems[0];
      if (!firstItem) return;

      firstItem.classList.add('active');
      const firstDataIndex = firstItem.getAttribute('data-index');

      dosageMediaItems.forEach(mediaItem => {
        if (mediaItem.getAttribute('data-index') === firstDataIndex) {
          mediaItem.classList.remove('d-none');
          forceRedrawSvg(mediaItem);
        } else {
          mediaItem.classList.add('d-none');
        }
      });
    }
  });
});
